import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BankAccount } from '../../../../banking/models/bank-account';

@Component({
  selector: 'app-variable-benefit-review-deposit-details',
  templateUrl: './variable-benefit-review-deposit-details.component.html',
  styleUrls: ['./variable-benefit-review-deposit-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitReviewDepositDetailsComponent {
  @Input() bankAccount!: BankAccount | null;
  @Input() isMandatoryRetirement: boolean = false;
}
